var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-checkout-step-shipping-address-street"},[(_vm.isDadataAvailable)?_c('page-checkout-step-shipping-address-street-dadata'):_c('page-checkout-step-shipping-address-street-standard')],1)}
var staticRenderFns = []

export { render, staticRenderFns }